export default {
  authorized: 'AUTHORIZED',
};
